import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface TourContextValue {
	startTour: (() => void) | null;
	register: (fn: () => void) => void;
	unregister: () => void;
}

const TourContext = createContext<TourContextValue | null>(null);

export function TourProvider({ children }: { children: ReactNode }) {
	const [startTour, setStartTour] = useState<(() => void) | null>(null);

	const register = useCallback((fn: () => void) => {
		setStartTour(() => fn);
	}, []);

	const unregister = useCallback(() => {
		setStartTour(null);
	}, []);

	return (
		<TourContext.Provider value={{ startTour, register, unregister }}>
			{children}
		</TourContext.Provider>
	);
}

// eslint-disable-next-line react-refresh/only-export-components
export function useTourContext() {
	const ctx = useContext(TourContext);
	if (!ctx) throw new Error("useTourContext must be used inside TourProvider");
	return ctx;
}
